module.exports = __webpack_public_path__ + "static/media/no.2ba685bf.webp";